
import { length, indexed, ofArray, item, collect, empty as empty_1, tryLast, append, singleton, fold, sortBy } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { int32ToString, defaultOf, comparePrimitives } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { empty, add, tryFind } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import * as react from "react";
import { toList } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { rangeDouble } from "../fable_modules/fable-library-js.5.13.0/Range.js";
import { split, printf, toText } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { keyValueList } from "../fable_modules/fable-library-js.5.13.0/MapUtil.js";
import { HTMLAttr } from "../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { ErrorInfo, ExtraErrorInfo, ReplaceType } from "./VerilogTypes.js";
import { Option, button } from "../fable_modules/Fulma.3.0.0/Elements/Button.fs.js";
import { Size_ISize } from "../fable_modules/Fulma.3.0.0/Common.fs.js";
import { value } from "../fable_modules/fable-library-js.5.13.0/Option.js";

/**
 * Returns the overlay which contains all the errors
 */
export function getErrorDiv(errorList) {
    const sortedByLineErrorList = sortBy((err_2) => (err_2.Line | 0), errorList, {
        Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
    });
    const lineToErrorsMap = fold((state_1, err_1) => {
        const matchValue = tryFind(err_1.Line, state_1);
        if (matchValue == null) {
            return add(err_1.Line, singleton(err_1), state_1);
        }
        else {
            return add(err_1.Line, append(matchValue, singleton(err_1)), state_1);
        }
    }, empty({
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    }), sortedByLineErrorList);
    let childrenElements;
    const matchValue_1 = tryLast(sortedByLineErrorList);
    childrenElements = ((matchValue_1 == null) ? empty_1() : collect((line) => {
        const matchValue_2 = tryFind(line, lineToErrorsMap);
        if (matchValue_2 == null) {
            return singleton(react.createElement("br", {}));
        }
        else {
            const sortedErrors = sortBy((e) => (e.Col | 0), matchValue_2, {
                Compare: (x, y) => (comparePrimitives(x, y) | 0),
            });
            const linechildren = collect((tupledArg) => {
                let props, arg, props_2;
                const index = tupledArg[0] | 0;
                const err = tupledArg[1];
                const prevErrorEnd = (index === 0) ? 0 : (((item(index - 1, sortedErrors).Col + item(index - 1, sortedErrors).Length) - 1) * 8.8);
                const _line = fold((s_2, v) => (s_2 + "-"), "", toList(rangeDouble(1, 1, err.Length)));
                return ofArray([(props = [["style", {
                    display: "inline-block",
                    marginLeft: (arg = (((err.Col - 1) * 8.8) - prevErrorEnd), toText(printf("%fpx"))(arg)),
                    pointerEvents: "stroke",
                }]], react.createElement("span", keyValueList(props, 1))), (props_2 = [new HTMLAttr(/* Class */ 65, ["error"]), ["style", {
                    pointerEvents: "auto",
                    fontSize: 16,
                    color: "rgb(255,0,0)",
                    background: "rgba(255,0,0,0)",
                }]], react.createElement("span", keyValueList(props_2, 1), _line)), react.createElement("span", {
                    className: "hide",
                }, err.Message)]);
            }, indexed(sortedErrors));
            return singleton(react.createElement("p", {}, ...linechildren));
        }
    }, toList(rangeDouble(1, 1, matchValue_1.Line))));
    const props_10 = [["style", {
        position: "absolute",
        display: "block",
        width: "100%",
        height: "-13px",
        top: "13px",
        left: "40px",
        right: "0",
        bottom: "0px",
        backgroundColor: "rgba(0,0,0,0)",
        fontWeight: "bold",
        color: "Red",
        zIndex: "2",
        pointerEvents: "none",
        whiteSpace: "pre-line",
    }]];
    return react.createElement("div", keyValueList(props_10, 1), ...childrenElements);
}

export function getSyntaxErrorInfo(error) {
    return new ErrorInfo(error.Line, error.Col, error.Length, error.Message, [new ExtraErrorInfo(error.Message, false, ReplaceType.NoReplace)]);
}

export function getErrorTable(errorList, addButton) {
    let children_18, props_18, props_20, children_26, children_24, props_24, children_32, props_32, props_34;
    const tableFormat = ofArray([(children_18 = [(props_18 = [["style", {
        width: "20%",
    }]], react.createElement("col", keyValueList(props_18, 1))), (props_20 = [["style", {
        width: "80%",
        whiteSpace: "pre-line",
    }]], react.createElement("col", keyValueList(props_20, 1)))], react.createElement("colgroup", {}, ...children_18)), (children_26 = [(children_24 = [(props_24 = [["style", {
        whiteSpace: "pre",
    }]], react.createElement("th", keyValueList(props_24, 1), "  Line")), react.createElement("th", {}, "Message")], react.createElement("tr", {}, ...children_24))], react.createElement("thead", {}, ...children_26))]);
    let tableLines;
    if (length(errorList) === 0) {
        const tLine_1 = singleton((children_32 = [(props_32 = [["style", {
            color: "Black",
            verticalAlign: "Middle",
            whiteSpace: "pre",
        }]], react.createElement("td", keyValueList(props_32, 1), " ")), (props_34 = [["style", {
            color: "Black",
            whiteSpace: "pre-wrap",
        }]], react.createElement("td", keyValueList(props_34, 1), "No errors"))], react.createElement("tr", {}, ...children_32)));
        tableLines = singleton(react.createElement("tbody", {}, ...tLine_1));
    }
    else {
        tableLines = collect((err_1) => {
            let error, tLine;
            return singleton((error = err_1, (error.ExtraErrors == null) ? defaultOf() : ((tLine = collect((tupledArg) => {
                let children_8, props_6, children_14, props_10, props_12;
                const extraMessage = tupledArg[1];
                const line_2 = error.Line | 0;
                const text = extraMessage.Text;
                const showLine = (tupledArg[0] === 0) ? ("  Line " + int32ToString(line_2)) : "";
                if (extraMessage.Copy) {
                    const suggestions_1 = split(text, ["|"], undefined, 1);
                    return singleton((children_8 = [(props_6 = [["style", {
                        color: "Black",
                        verticalAlign: "Middle",
                        whiteSpace: "pre",
                    }]], react.createElement("td", keyValueList(props_6, 1), showLine)), ((replaceType) => ((line) => ((col) => {
                        let props_2;
                        const buttons = collect((suggestion) => {
                            let props;
                            return ofArray([(props = [["style", {
                                whiteSpace: "pre",
                            }]], react.createElement("span", keyValueList(props, 1), "    ")), button(ofArray([new Option(/* OnClick */ 18, [(_arg) => {
                                addButton([suggestion, replaceType, line, col]);
                            }]), new Option(/* Size */ 1, [Size_ISize.IsSmall])]), singleton(suggestion))]);
                        }, toList(suggestions_1));
                        const line_1 = append(singleton((props_2 = [["style", {
                            color: "Red",
                            fontStyle: "Italic",
                            verticalAlign: "Middle",
                        }]], react.createElement("span", keyValueList(props_2, 1), "\tDo you mean:"))), buttons);
                        const props_4 = [["style", {
                            whiteSpace: "pre",
                        }]];
                        return react.createElement("td", keyValueList(props_4, 1), ...line_1);
                    })))(extraMessage.Replace)(line_2)(error.Col)], react.createElement("tr", {}, ...children_8)));
                }
                else {
                    return singleton((children_14 = [(props_10 = [["style", {
                        color: "Black",
                        verticalAlign: "Middle",
                        whiteSpace: "pre",
                    }]], react.createElement("td", keyValueList(props_10, 1), showLine)), (props_12 = [["style", {
                        color: "Black",
                        whiteSpace: "pre-wrap",
                    }]], react.createElement("td", keyValueList(props_12, 1), text))], react.createElement("tr", {}, ...children_14)));
                }
            }, indexed(ofArray(value(error.ExtraErrors)))), react.createElement("tbody", {}, ...tLine)))));
        }, sortBy((err) => (err.Line | 0), errorList, {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        }));
    }
    const tableChildren = append(tableFormat, tableLines);
    if (length(tableLines) !== 0) {
        const props_40 = [["style", {
            fontSize: "16px",
            tableLayout: "Fixed",
            width: "100%",
            borderRight: "groove",
            borderLeft: "groove",
        }]];
        return react.createElement("table", keyValueList(props_40, 1), ...tableChildren);
    }
    else {
        return react.createElement("table", {});
    }
}

export function getLineCounterDiv(linesNo) {
    let children_2, arg_1;
    const childrenElements$0027 = append(collect((no) => {
        let children;
        return ofArray([(children = [toText(printf("%i"))(no)], react.createElement("span", {}, ...children)), react.createElement("br", {})]);
    }, toList(rangeDouble(1, 1, linesNo))), singleton((children_2 = [(arg_1 = ((linesNo + 1) | 0), toText(printf("%i"))(arg_1))], react.createElement("span", {}, ...children_2))));
    const props_6 = [["style", {
        position: "absolute",
        display: "block",
        width: "3%",
        height: "-5px",
        top: "5px",
        left: "2px",
        right: "0",
        bottom: "0px",
        backgroundColor: "rgba(255,0,0,0)",
        color: "#7f7f7f",
        zIndex: "2",
        pointerEvents: "none",
        textAlign: "right",
        whiteSpace: "pre-line",
    }]];
    return react.createElement("div", keyValueList(props_6, 1), ...childrenElements$0027);
}

export const infoHoverableElement = (() => {
    let children_4, props;
    const example = "\tTHIS IS AN EXAMPLE OF A VALID VERILOG FILE\r\n----------------------------------------------------------\r\nmodule decoder(\r\n\tinput bit [15:0] instr,\r\n\tinput bit n,z,c,\r\n\toutput bit mux1sel,jump,\r\n\toutput bit [2:0] aluF\r\n);\r\n\tbit cond = n|z|c;\r\n\tassign mux1sel = instr[15]&cond | instr[14];\r\n\tassign j = instr[8]&(n|c);\r\n\tassign aluF = intr[10:8];\r\nendmodule";
    const props_6 = [["style", {
        position: "absolute",
        display: "block",
        width: "100%",
        height: "100%",
        top: "-10px",
        left: "104px",
        right: "0",
        bottom: "0",
        backgroundColor: "rgba(0,0,0,0)",
        color: "#7f7f7f",
        zIndex: "2",
        pointerEvents: "none",
        textDecoration: "underline",
        textDecorationColor: "rgb(0,0,255)",
        textAlign: "left",
        whiteSpace: "pre-wrap",
    }]];
    const children_6 = [(children_4 = [(props = [new HTMLAttr(/* Class */ 65, ["error"]), ["style", {
        pointerEvents: "auto",
        fontSize: 16,
        color: "rgb(0,0,255)",
        background: "rgba(255,0,0,0)",
    }]], react.createElement("span", keyValueList(props, 1), "example")), react.createElement("span", {
        className: "hide",
    }, example)], react.createElement("p", {
        className: "info",
    }, ...children_4))];
    return react.createElement("div", keyValueList(props_6, 1), ...children_6);
})();

